/**
 * Ciblage des notifications de tournée (module pur, testable) : décide si un
 * évènement DEMO_EVENT concerne un utilisateur donné. Découplé du WebSocket et
 * du store pour rester sans effet de bord.
 */

/**
 * Évènements « de tournée » qui concernent TOUS les parents de l'itinéraire :
 * le bus a pris la route, et les imprévus (accident, panne…). En revanche
 * l'arrivée / le départ de l'école sont CIBLÉS (targetParentEmail) : seuls les
 * parents des enfants effectivement montés à bord sont notifiés.
 */
export const TOUR_WIDE_KINDS = ['STARTED', 'INCIDENT']

export interface DemoEventMsg {
  kind?: string
  targetParentEmail?: string
  stopLabel?: string
  itineraryId?: string
  message?: string
}
export interface EventViewer {
  role?: string
  email?: string
}
export interface ParentStopRef {
  itineraryId?: string | null
  stopLabel?: string | null
}

/**
 * Un évènement concerne-t-il l'utilisateur ? Un parent est concerné par : ses
 * propres enfants (targetParentEmail), son arrêt choisi (stopLabel + itineraryId),
 * et les évènements de tournée (bus en route, arrivée/départ école, imprévu) de
 * l'itinéraire de son arrêt. Les superviseurs (admin/manager/dispatcher) voient tout.
 */
export function eventConcernsParent(msg: DemoEventMsg, me: EventViewer | null, parent: ParentStopRef): boolean {
  if (!me) return false
  if (me.role === 'ADMIN' || me.role === 'MANAGER' || me.role === 'DISPATCHER') return true

  const { targetParentEmail: target, stopLabel, itineraryId, kind } = msg

  if (target && me.email === target) return true
  // Arrêt choisi par le parent.
  if (parent.stopLabel && stopLabel && parent.stopLabel === stopLabel &&
      (!itineraryId || !parent.itineraryId || itineraryId === parent.itineraryId)) return true
  // Évènements de tournée (en route, école, imprévu) sur l'itinéraire du parent.
  if (kind && TOUR_WIDE_KINDS.includes(kind)) {
    if (parent.itineraryId && itineraryId && parent.itineraryId === itineraryId) return true
    // Démo sans itinéraire ni cible : message général.
    if (!itineraryId && !target) return true
  }
  return false
}
